/**
 * Single saved-card row. Shows brand, last 4 digits, expiry, and a
 * "Pay with this card" button that redirects to /checkout with the
 * `storedPaymentMethodId` query param prefilled.
 */

import React from 'react';
import { Box, Button, Typography } from '@mui/material';

import { UI_CONFIG } from '../../../utils/constants';
import type { SavedPaymentMethod } from '../../../types/api';

export interface SavedCardItemProps {
  card: SavedPaymentMethod;
  onPayWithThis: (storedPaymentMethodId: string) => void;
}

const SavedCardItem: React.FC<SavedCardItemProps> = ({ card, onPayWithThis }) => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      p: 2,
      borderBottom: '1px solid #2a2a2a',
    }}
  >
    <Box>
      <Typography sx={{ color: UI_CONFIG.TEXT_COLOR, fontWeight: 600 }}>
        {(card.brand || 'CARD').toUpperCase()} •••• {card.last4 || '----'}
      </Typography>
      <Typography sx={{ color: UI_CONFIG.SECONDARY_TEXT_COLOR, fontSize: '0.85rem' }}>
        Expires {card.expiry_month || '--'}/{card.expiry_year || '--'}
      </Typography>
    </Box>
    <Button
      variant="contained"
      onClick={() => onPayWithThis(card.id)}
      sx={{ background: UI_CONFIG.PRIMARY_COLOR }}
    >
      Use saved card
    </Button>
  </Box>
);

export default SavedCardItem;
